const CaterBackdrop = ({ scale }: { scale: number }) => {
  return (
    <div className="absolute inset-0 z-0 pointer-events-none w-screen h-screen  ">
      <div
        className="w-screen h-screen max-w-screen-2xl mx-auto transform-gpu origin-center transition-transform duration-500"
        style={{
          transform: `scale(${scale})`,
        }}
      >
        <div className="relative w-full h-full">
          {/* Top Left cluster */}
          <div
            className="orb z-30 absolute
              top-32 left-10 w-28
              md:top-5 md:left-32 md:w-64"
          />
          <div
            className="orb z-10 absolute
              top-40 left-2 w-14
              md:top-52 md:left-0
              md:w-32"
          />
          <div
            className="orb z-20 absolute
              top-24 left-2 w-14
              md:top-20 md:left-5 md:w-36"
          />
          {/* Bottom Right cluster */}
          <div
            className="orb z-30 absolute
              bottom-5 right-10
              md:bottom-3 md:right-0
              w-64 md:w-96"
          />
        </div>
      </div>
    </div>
  );
};

export default CaterBackdrop;
